export const MODES = ["ONEWAY", "HOURLY", "LONGDISTANCE"];
